var o={holyContainer:"layout-topbar-phone-button-style-module_holyContainer__N3BYr"};export{o as default};
//# sourceMappingURL=layout-topbar-phone-button.style.module.scss.js.map
